/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.offerings.create.policies.controllers', [
  'ui.bootstrap',
  'acme.common.service.membership',
  'acme.common.service.membership.offering',
  'acme.common.service.rulesEngine',
  'acme.view.application.membership.offerings.create.policies.modals.email.controllers'
])

.controller('MembershipOfferingsCreatePoliciesController', ['$scope', '$uibModal', 'MembershipService', 'MembershipOfferingService', 'RulesEngineService', function($scope, $uibModal, MembershipService, MembershipOfferingService, RulesEngineService) {

    $scope.membershipOfferingsCreatePolicies = {

      model: [],

      offering: {},
      addModal: {},

      channels: [
        'online',
        'pointOfSale',
        'insideSalesIndividual',
        'customerRep',
        'salesforce',
        'kiosk',
      ],

      init: function() {
        $scope.$on('MembershipOfferingsCreateController::Save', this.onMembershipOfferingsCreateControllerSave);
        $scope.$on('MembershipOfferingsCreateController::Update', this.onMembershipOfferingsCreateControllerUpdate);
      },

      process: function(rules, initialize) {

        var i, ii,
            offeringAction,
            r = [];

        for (i = 0, ii = rules.length; i < ii; i++) {

          if (initialize) {
            // Initialize with new offering
            offeringAction = MembershipService.createOfferingAction();
          }else{
            // Update existing offering
            offeringAction = rules[i];
          }

          // Normalize object
          if (rules[i].name) {
            offeringAction.name = rules[i].name;
            offeringAction.action = RulesEngineService.nameToAction(rules[i].name);
          }else if (rules[i].action) {
            offeringAction.name = RulesEngineService.actionToName(rules[i].action);
          }

          offeringAction.salesChannelOptions = angular.copy(this.createSalesChannelOptions(offeringAction));

          r.push(offeringAction);

        }

        return r;

      },

      createSalesChannelOptions: function(offeringAction) {
        var i, ii,
            r = [],
            saleChannel,
            hasSFChannel = false,
            hasCSRChannel = false;

        for (i = 0, ii = offeringAction.confirmationEmailRestrictions.length; i < ii; i++) {
          saleChannel = offeringAction.confirmationEmailRestrictions[i].saleChannel;
          if (saleChannel && this.channels.includes(saleChannel)) {
            r.push({
              saleChannel: offeringAction.confirmationEmailRestrictions[i].saleChannel,
              canSendConfirmationEmail: offeringAction.confirmationEmailRestrictions[i].canSendConfirmationEmail,
              saleChannelEntity: MembershipService.findSalesChannel(offeringAction.salesChannels, offeringAction.confirmationEmailRestrictions[i].saleChannel).salesChannel
            });
          }
        }

        for (i = 0, ii = r.length; i < ii; i++) {
          if (r[i].saleChannel === 'salesforce') {
            hasSFChannel = true;
          }else if (r[i].saleChannel === 'customerRep') {
            hasCSRChannel = true;
          }
        }

        if (!hasSFChannel) {
          r.splice(3, 0, {
            saleChannel: 'salesforce',
            canSendConfirmationEmail: true,
            saleChannelEntity: MembershipService.findSalesChannel(offeringAction.salesChannels, 'salesforce').salesChannel
          });
        }

        if (!hasCSRChannel) {
          r.push({
            saleChannel: 'customerRep',
            canSendConfirmationEmail: true,
            saleChannelEntity: MembershipService.findSalesChannel(offeringAction.salesChannels, 'customerRep').salesChannel
          });
        }

        return r;

      },

      showConfirmationMessage: function(rule) {

        var self = $scope.membershipOfferingsCreatePolicies;

        self.addModal = $uibModal.open({
          templateUrl: 'views/application/views/membership/offerings/create/policies/modals/email/email.tpl.html',
          size: 'lg',
          controller: 'MembershipOfferingsCreatePoliciesModalsEmailController',
          resolve: {
            currentMessage: function() {
              return rule.confirmationMessage;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.addModal.result.then(function (message) {
          rule.confirmationMessage = message;
        }, function () {
          // Do nothing
        });

      },

      updateChannel: function(channel) {
        if (!(channel.saleChannelEntity.enabled)) {
          channel.canSendConfirmationEmail = false;
        }
      },

      isPolicy: function(policy, name) {
        return (policy.name === name);
      },

      save: function() {

        var i, ii,
            j, jj,
            offeringAction,
            hasCSRChannel = false;

        for (i = 0, ii = this.model.length; i < ii; i++) {
          offeringAction = this.model[i];

          for (j = 0, jj = offeringAction.confirmationEmailRestrictions.length; j < jj; j++) {
            if (offeringAction.confirmationEmailRestrictions[j].saleChannel === 'customerRep') {
              hasCSRChannel = true;
              break;
            }
          }

          if (!hasCSRChannel) {
            offeringAction.confirmationEmailRestrictions.push({
              saleChannel: 'customerRep',
              canSendConfirmationEmail: true,
              saleChannelEntity: MembershipService.findSalesChannel(offeringAction.salesChannels, 'customerRep').salesChannel
            });
          }

        }

      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onMembershipOfferingsCreateControllerSave: function(e, data) {

        var self = $scope.membershipOfferingsCreatePolicies;

        self.save();
        MembershipOfferingService.policies = angular.copy(self.model);
        MembershipOfferingService.ready.policies = true;

      },
      
      onMembershipOfferingsCreateControllerUpdate: function(e, data) {

        var self = $scope.membershipOfferingsCreatePolicies;

        self.offering = data.offering;
        self.lifecycleRules = data.lifecycleRules;

        if (self.offering.actions instanceof Array &&
            self.lifecycleRules instanceof Array &&
            self.offering.actions.length === self.lifecycleRules.length) {
          // Offering is initialized with actions use the instance
          self.model = self.process(angular.copy(self.offering.actions));
        }else{
          // Initialize offering with lifecycle rules template defaults
          self.model = self.process(angular.copy(self.lifecycleRules), true);
        }

        MembershipOfferingService.policies = angular.copy(self.model);

        MembershipOfferingService.loaded.policies = true;

      }

    };

    $scope.membershipOfferingsCreatePolicies.init();

}]);